.item {
  font-size: 90%;
  margin: 0;
  padding: 0;
}

.item a {
  color: var(--popup-menu-color);
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  width: 100%;
  box-sizing: border-box;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  text-decoration: none;
}

.item a:hover {
  color: var(--popup-menu-color);
  background-color: var(--popup-menu-hover-item);
}

.icon {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.5rem;
  flex-shrink: 0;
}

.disabled {
  pointer-events: none;
  color: var(--popup-menu-disabled);
}

.disabled a {
  color: var(--popup-menu-disabled);
}
